import {
  Body,
  Card,
  H4,
  Stack,
  useWindowProperties,
} from '@qred/components-library';
import React from 'react';
import AppShell from '~/components/shared/AppShell/AppShell';
import useTranslate from '~/hooks/useTranslate';
import { StepsContainer } from '~/styles/BaseStyledComponents';

/**
 * Landing page after a standalone passcode reset succeeds. Static and
 * auth-free by design (see useShouldUseSvcOnboardingAuth). Reloading or
 * revisiting this exact page never re-runs WebID identification against the
 * now-used reset link.
 */
const CreatePasscodeDone = () => {
  const translate = useTranslate();
  const { isDesktop, isMobile } = useWindowProperties();

  return (
    <AppShell>
      <StepsContainer>
        <Card
          bg="miscellaneous.white"
          mt={isMobile ? 0 : 60}
          p={0}
          w="100%"
          display="flex"
          style={{ overflow: 'auto', flexGrow: 1 }}
        >
          <Stack
            spacing="xxl"
            align="center"
            p="1.5em"
            style={{ width: '100%' }}
            data-testid="create-passcode-done"
          >
            <H4 data-record>{translate('CreatePasscode.SuccessTitle')}</H4>
            <img
              src="/success_check.png"
              alt=""
              style={{
                alignSelf: 'center',
                width: isDesktop ? '240px' : '160px',
                height: isDesktop ? '240px' : '160px',
              }}
            />
            <Body size="lg" color="Text/Default" align="center" data-record>
              {translate('CreatePasscode.SuccessDescriptionStandalone')}
            </Body>
          </Stack>
        </Card>
      </StepsContainer>
    </AppShell>
  );
};

export default CreatePasscodeDone;
